(function () {
    angular.module('core')
      .controller('DomainStandardModalController', [
          '$scope',
          'customer',
          'domain',
          'selectedStandard',
          'grade',
          '$window',
          '$modalInstance',
          DomainStandardModalController]);

    function DomainStandardModalController(
      $scope,
      customer,
      domain,
      selectedStandard,
      grade,
      $window,
      $modalInstance
    ) {

        $scope.splitStandardsIntoRows = splitStandardsIntoRows;
        $scope.displayStandard = displayStandard;
        $scope.modalClose = modalClose;
        $scope.getDomainStyle = getDomainStyle;
        $scope.linkToStandard = linkToStandard;
        $scope.isLinkToStandardEnabled = isLinkToStandardEnabled;

        // determine if the short description should be shown
        $scope.showShortDescription = customer.isAstDbl() || customer.isAstUk();

        // display the buttons into rows each has 3 buttons by default
        $scope.buttonsPerRow = $scope.showShortDescription ? 2 : 3;
        $scope.maxChar = 35;

        function splitStandardsIntoRows(standards) {
            var newStandards = [];

            for (var i = 0; i < standards.length; i += $scope.buttonsPerRow) {
                newStandards.push(standards.slice(i, i + $scope.buttonsPerRow));
            }

            return newStandards;
        }

        function displayStandard(standard) {
            $scope.standard = standard;
        }

        $scope.breadcrumbHeader = grade.name + " &raquo; " + customer.getAcademicStandard().academic_standard_title_in_reports;
        $scope.domain = domain;

        // init empty standard
        $scope.standard = {
            name: "",
            description: ""
        };

        // split standards into rows with 3 buttons
        $scope.domainStandards = $scope.splitStandardsIntoRows(domain.standards);

        // init the first standards
        if (selectedStandard) {
            $scope.displayStandard(selectedStandard, 0, 0);
        } else if (domain.standards.length > 0) {
            var standard = domain.standards[0];
            $scope.displayStandard(standard, 0, 0);
        }

        function modalClose() {
            $modalInstance.close();
        }

        function getDomainStyle(standard, buttonIndex) {
            var result = $scope.buttonsPerRow <= 2 ? "" : ["column-left ", "column-center ", "column-right "][buttonIndex];
            if ($scope.standard && $scope.standard.code === standard.code) {
                result += "button-selected";
            }
            else {
                result += "button-normal";
            }
            return result;
        }

        function linkToStandard() {
            if ($scope.standard === undefined) {
                return;
            }

            var domain = $scope.standard.domain;

            if (!domain) {
                return;
            }

            var standardDescriptor = {
                grade: grade.id,
                domain: domain.code,
                standard: $scope.standard.code
            };

            $modalInstance.close(standardDescriptor);
        }

        function isLinkToStandardEnabled() {
            if ($scope.standard === undefined) {
                return false;
            }

            return $scope.standard.domain;
        }

    }

})();
